import React from 'react';

// DL.1 - Αντίγραφο ιατρικού φακέλου νοσηλείας
const DL1 = ({ formData, updateFormData }) => {
  const handleChange = (e) => {
    updateFormData({ [e.target.name]: e.target.value });
  };

  const validateAMKA = (amka) => {
    return /^\d{11}$/.test(amka);
  };

  const handleAMKAChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 11) {
      updateFormData({ patientAmka: value });
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    // Allow common phone lengths; keep it permissive but numeric-only
    if (value.length <= 15) {
      updateFormData({ phone: value });
    }
  };

  return (
    <div>
      <div className="alert alert-info" style={{ marginBottom: '20px' }}>
        <p style={{ margin: 0 }}>
          <strong>Οδηγία:</strong> Παρακαλούμε συμπληρώστε τα παρακάτω πεδία (* Υποχρεωτικά)
        </p>
      </div>

      <div className="form-group">
        <label htmlFor="patientAmka">
          ΑΜΚΑ ασθενή <span className="required">*</span>
        </label>
        <input
          type="text"
          id="patientAmka"
          name="patientAmka"
          value={formData.patientAmka || ''}
          onChange={handleAMKAChange}
          placeholder="12345678901"
          maxLength="11"
          required
        />
        {formData.patientAmka && !validateAMKA(formData.patientAmka) && (
          <small style={{ color: '#e74c3c', display: 'block', marginTop: '5px' }}>
            Το AMKA πρέπει να είναι ακριβώς 11 ψηφία
          </small>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="periodOfHospitalization">
          Περίοδος νοσηλείας <span className="required">*</span>
        </label>
        <input
          type="text"
          id="periodOfHospitalization"
          name="periodOfHospitalization"
          value={formData.periodOfHospitalization || ''}
          onChange={handleChange}
          placeholder="π.χ. 15/01/2024 - 20/01/2024"
          required
        />
        <small style={{ color: '#666', display: 'block', marginTop: '5px' }}>
          Εισάγετε την περίοδο νοσηλείας (από - έως)
        </small>
      </div>

      <div className="form-group">
        <label htmlFor="clinic">
          Κλινική νοσηλείας
        </label>
        <input
          type="text"
          id="clinic"
          name="clinic"
          value={formData.clinic || ''}
          onChange={handleChange}
          placeholder="π.χ. Παθολογική Κλινική"
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="email">
            Email <span className="required">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email || ''}
            onChange={handleChange}
            placeholder="example@email.com"
            required
          />
          <small style={{ color: '#666', display: 'block', marginTop: '5px' }}>
            Το ίδιο με αυτό που δηλώσατε στην ΥΔ ή Εξουσιοδότηση
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="phone">
            Τηλ. Επικοινωνίας <span className="required">*</span>
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone || ''}
            onChange={handlePhoneChange}
            placeholder="2101234567"
            inputMode="numeric"
            pattern="\d{10,15}"
            title="Εισάγετε μόνο αριθμούς (10-15 ψηφία)"
            required
          />
        </div>
      </div>
    </div>
  );
};

export default DL1;
